export default __webpack_public_path__ + "static/media/poster-sdg-1.9d88d88a.png";